import { Stack } from "@mui/material";
import { CbhIcon, type IconType, Text } from "@src/appV2/redesign/system/ui-components";
import type { IntentVariant } from "@src/appV2/redesign/system/ui-theme";

interface RoleListItemDescriptionRowProps {
  iconType: IconType;
  intent: IntentVariant;
  text: string;
}

export function RoleListItemDescriptionRow(props: RoleListItemDescriptionRowProps) {
  const { iconType, intent, text } = props;

  return (
    <Stack
      sx={{ flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: 3 }}
    >
      <CbhIcon
        type={iconType}
        size="small"
        color={(theme) => theme.palette.intent?.[intent].icon}
      />
      <Text
        semibold
        variant="body2"
        sx={(theme) => ({ color: theme.palette.intent?.[intent].text })}
      >
        {text}
      </Text>
    </Stack>
  );
}
